import { type } from "../types/types";

export const set_vendor_store = (vendorStore) => (dispatch) => {
  dispatch({
    type: type.SET_VENDOR_STORE,
    vendorStore: vendorStore,
  });
};
